module.exports = __webpack_public_path__ + "img/mile5-m@2.f3a72e1d.jpg";